import { Stack, Typography } from "@mui/material";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useProduct } from "src/context/ProductProvider";
import { useIsMobile } from "src/hooks/useIsMobile";

const Shipping = () => {
  const isMobile = useIsMobile();
  const billingModel = useProduct((product) => product.billing_model);
  const slug = useProduct((product) => product.slug);
  const { t } = useTranslation();
  const page = "payment-information";
  const shippingComponent = "shipping";

  const text = useMemo(() => {
    if (["mhl-ot", "ed-ot", "iwl-ot", "wp-ot"].includes(slug)) {
      return t(`${page}.${shippingComponent}.${slug}.${billingModel}.header`);
    }

    return t(`${page}.${shippingComponent}.${billingModel}.header`);
  }, [billingModel, slug, t]);

  const subtext = useMemo(() => {
    if (["iwl-ot"].includes(slug)) {
      return t(`${page}.${shippingComponent}.${slug}.subtext`);
    }

    return null;
  }, [slug, t]);

  return (
    <Stack gap={1}>
      <Typography variant={isMobile ? "h6" : "h5"} fontWeight={600}>
        {text}
      </Typography>
      {subtext ? (
        <Typography variant={isMobile ? "body2" : "body1"}>
          {subtext}
        </Typography>
      ) : null}
    </Stack>
  );
};

export default Shipping;
